import React, { useEffect, useState } from 'react';
import CSSTransform from '../../common/transition/Animation';
import SliderWrapper from 'jd-library/SliderWrapper';
import useOnScroll from 'jd-library/useOnScroll';
import { useDispatch, connect, useSelector} from 'react-redux';
import axios from 'axios';
import ActionModal from '../../common/action-modal/ActionModal';
import historyHandler from 'jd-library/historyHandler';
import SingleProductList from './SingleProductlist';
import "./product-conflict.scss";
import toastMessageActions from 'jd-library/toastMessageActions';
import { getJdMartParams } from '../../utills';

const SuggestProdList = (props) => {
    const scrollHandler = (e) => {
		props.setScroll(e.target.scrollTop > 5);
	}
    return(
        <>
            <div className={`section-name ${props.scrolled ? 'raised' : ''}`} style={{ top: `${props.topStyle}px` }}>
                SUGGESTED PRODUCT
            </div>
            <div className="suggested-prod-holder" onScroll={(e) => { scrollHandler(e) }}>
                {props.suggestList.map((cur,index)=>{
                    return(
                        <SingleProductList
                            prodData={cur}
                            btnLebal={'SELECT THIS PRODUCT'}
                            handleProductClick={props.handleProductClick}
                            getUom={props.getUom}
                            type={'suggested'}
                        />
                    )
                })}
            </div>
        </>    
    )
}

const ProductConflictSlider = (props) => {
    const [scrolled, setScroll] = useState(false);
    const [showActionModal, toggleActionModal] = useState({show : false});
    const [conflictData, setConflictData] = useState({sourceInventoryCreateCommand:{},targetInventoryCreateCommandList:[]});
    const [scrollEl, setScrollEl] = useState(null);
    const dispatch = useDispatch();
    const sliderHeader = typeof document === 'object' && document.getElementsByClassName("prod-conflict-slider-header");
    const currentProdDiv = typeof document === 'object' && document.getElementsByClassName("current-prod-holder");
    const headerOffSet = sliderHeader && sliderHeader[0] && sliderHeader[0].offsetHeight;
    const currentProdOffSet = currentProdDiv && currentProdDiv[0] && currentProdDiv[0].offsetHeight;
    const topSuggested = headerOffSet + currentProdOffSet;
    const getUom = (uom, forceSingular, getUomType) => {
		// return "";
		let uomObj = props?.uomJsonMap?.[uom];
		if(getUomType && uomObj){
			return uomObj.uomType;
		}
		if (forceSingular) {
			return uomObj ? uomObj.singular : uom;
		}
		if (productData.minOrderQuantity == 1) {
			return uomObj ? uomObj.singular : uom;
		} else {
			return uomObj ? uomObj.plural : uom;
		}
	};
    let leftIcons = [
        {
            className: 'icon-HDRback',
            onClick: () => {
                window.history.back();
            }
        }
    ], rightIcons = [
        {
            className: 'icon-HDRcross',
            onClick: () => {
                historyHandler.closeCurrent()
            }
        }
    ]

    useEffect(() => {
        if(props.barCodeConflictId){
            axios.get(`/vendorapis/products/barcode/getBarcodeConflict?barcodeConflictId=${props.barCodeConflictId}&token=${props.token}`)
            .then(({ data }) => {
                if(data.data){   
                    setConflictData(data.data);
                }
            })
        }
    }, [])

    useOnScroll({
        callback : (e,scrollObj) => {
          if(scrollObj.currScroll.scrollTop){
            setScroll(true);
          }else{
             setScroll(false)
          }
        },
        element : !scrollEl ? null : scrollEl,
        deps: [scrollEl]
    })

    const handleCloseModal = () =>{
        toggleActionModal({show : false});
    }
    const onConfirmation = () =>{
        let jdMartParams = getJdMartParams();
        let url = '/vendorapis/products/barcode/'
        if(showActionModal.type == 'retain'){
            url += 'retainConflictedProduct?';
        }else{
            url += 'resolveBarcodeConflict?';
            url += 'targetTemplateId='+showActionModal.id+'&';
        }
        url += 'barcodeConflictId='+props.barCodeConflictId+'&token='+props.token;
        if(jdMartParams.sourceId){
            url += `&sourceId=${jdMartParams.sourceId}`;
        }
        axios.get(url)
        .then(({ data }) => {
            if(data.isSuccess){   
                toggleActionModal({show : false});
                historyHandler.closeAll();
            }else if(data.isError){
                toggleActionModal({show : false});
                dispatch(toastMessageActions.showMessage({
                    message: data.message,
                    type: 'error',
                    showReduxToast: true,
                    duration: 4000
                }))
            }
        })

    }

    const handleProductClick= (data,type) =>{
        let actionObj = {};
        if(type == 'retain'){
            actionObj={
                title : 'Retain Current Product',
                content : (<><div>Please confirm on the selection of <span className={"prod-conflict-modal-product-title"}>{data.productName}</span></div><div>Once selected, this cannot be reverted back.</div></>)
            }
        }else{
            actionObj={
                title : 'Confirm Product Selection',
                content : (<>Are you sure you want to retain the current product <span className={"prod-conflict-modal-product-title"}>{data.productName}</span></>)
            }
        }
        toggleActionModal({
            ...actionObj,
            type,
            id: data.productId,
            show : true
        })
    }


    let titleHeading = `Select Product from Library`;
    return (
        <>
            <SliderWrapper
                header={{
                    heading: titleHeading,
                    variant: 'secondary',
                    className: 'prod-conflict-slider-header',
                    leftIcons: props.isMobile ? leftIcons : [],
                    rightIcons: props.isMobile ? [] : rightIcons,
                }}
                onHidden={ 
                    props.onHidden
                }
                slider={{
                    className: 'prod-conflict-animate-slider'
                }}
                updateScrollContRef={(scrollref) => {
                    setScrollEl(scrollref)
                }}
            >
                <div className="prod-conflict-container">
                    <div className={`current-prod-holder ${scrolled ? 'raised' : ''}`} style={{ top: `${headerOffSet}px` }}>
                        <div className="section-name">
                            CURRENT PRODUCT
                        </div>
                        <SingleProductList
                            prodData={conflictData.sourceInventoryCreateCommand}
                            btnLebal={'RETAIN CURRENT DETAILS'}
                            handleProductClick={handleProductClick}
                            type={'retain'}
                            getUom={getUom}
                        />
                    </div>
                    <CSSTransform>
                        <SuggestProdList
                            suggestList={conflictData.targetInventoryCreateCommandList}
                            getUom={getUom}
                            handleProductClick={handleProductClick}
                            topStyle={topSuggested}
                            setScroll={setScroll}
                            scrolled={scrolled}
                        />
                    </CSSTransform>
                </div>
            </SliderWrapper>
            {showActionModal.show ?  
				<ActionModal
					onHidden={handleCloseModal}
					title={showActionModal.title}
					content={showActionModal.content}
					btnName= {'Confirm Product'}
					variant={'primary'}
					onclick={onConfirmation}
				/>
				: null
			}
        </>
    )
};
const mapStateToProps = state => {
	return {
        isMobile:state.library.deviceData.isMobile,
        uomJsonMap: state.uom.uomJsonMap,
        token: state.session.token,
	};
};
export default connect(mapStateToProps)(ProductConflictSlider);